import { useQuery } from '@mm/hooks';
import { useWebsiteReportSummaryActions } from '@mm/state/actions/WebsiteReportSummaryActions';
import { UtmCampaign } from '@mm/state/interfaces/lostLeadsReport';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { MODALS_TYPE } from '@mm/state/modules/modalsState/types';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import validator from 'validator';
import { Routes } from '../../../../routes/top-level-routes';
import { useAnalyzeWebsiteTraffic } from '../AnalyzeWebsiteTraffic/use-analyze-website-traffic';
import { useGetWebsiteTraffic } from '../hooks/use-get-website-traffic';
import { campaignParser } from './campaign-parser';
import { extractDomainName } from './constants';
import { LLRReportVersion } from './WebsiteReport';

export const useWebsiteReportModals = () => {
  const [activeStep, setActiveStep] = useState(2);
  const [showPaidTrafficROI, setShowPaidTrafficROI] = useState(false);
  const queryParams = useQuery();
  const isNonSQLWelcomeScreen = window.location.pathname.includes('/welcome');
  const websiteURL =
    window.location.pathname === '/report'
      ? ''
      : extractDomainName(window.location.pathname) || '';

  const pathVersion = window.location.pathname.split(
    '/',
  )?.[3] as LLRReportVersion;

  const skipEmailReportModal =
    window.location.search.includes('skip_email_report_modal') ||
    window.location.search.includes('secret');

  const isWhiteLabel = window.location.search.includes('whitelabel');

  const history = useHistory();

  const {
    openEditWebsiteURLModal,
    openAnalyzeWebsiteTrafficModal,
    openClarifyWebsiteTrafficModal,
    closeModal,
  } = useModalActions();
  const { reset: resetTraffic } = useWebsiteReportSummaryActions();
  const { emailState } = useAnalyzeWebsiteTraffic({ website: websiteURL });

  const openTrafficAbsentModal = () => {
    openClarifyWebsiteTrafficModal({
      website: websiteURL,
      openSignupModal,
    });
  };

  const openAnalyzeWebsiteTraffic = (campaign: UtmCampaign | null) => {
    if (!isWhiteLabel) {
      openAnalyzeWebsiteTrafficModal({
        website: websiteURL,
        campaign,
      });
    }
  };

  const openSignupModal = () => {
    setActiveStep(3);
    history.push({
      pathname: Routes.reportUserRegister.path,
      state: { website: websiteURL, email: emailState },
    });
  };

  const openEditUrlModal = () => {
    setActiveStep(1);
    if (!isWhiteLabel) {
      openEditWebsiteURLModal({
        onClose: () => {
          resetTraffic();
          setActiveStep(2);
          closeModal(MODALS_TYPE.EDIT_WEBSITE_URL);
        },
        hideClose: !websiteURL,
      });
    }
  };

  const { retrieveStats } = useGetWebsiteTraffic({
    onTrafficAbsent: openTrafficAbsentModal,
    onNonUSTraffic: openSignupModal,
    setShowPaidTrafficROI,
  });

  useEffect(() => {
    (async () => {
      if (websiteURL && validator.isURL(websiteURL)) {
        const parsedCampaign = campaignParser(queryParams);
        if (!isNonSQLWelcomeScreen) {
          if (!skipEmailReportModal) {
            openAnalyzeWebsiteTraffic(parsedCampaign);
          }
          setActiveStep(2);
          await retrieveStats(websiteURL);
        }
      } else if (!isNonSQLWelcomeScreen) {
        openEditUrlModal();
      }
    })();
  }, []);

  return {
    openTrafficAbsentModal,
    openSignupModal,
    openEditUrlModal,
    openAnalyzeWebsiteTraffic,
    websiteURL,
    activeStep,
    showPaidTrafficROI,
    pathVersion,
  };
};
